export const OPEN_DEVICE_RECONFIG_MODAL = 'events/OPEN_DEVICE_RECONFIG_MODAL';

export const openDeviceReconfigModal = () => ({
  type: OPEN_DEVICE_RECONFIG_MODAL,
});
